import ArticleLayout from "@/components/feature/ArticleLayout";
import { articleDataList } from "@/mocks/articles";

export default function BeginnersGuidePage() {
  const article = articleDataList.find((a) => a.slug === "mulebuy-spreadsheet-beginners-guide")!;
  return <ArticleLayout article={article} />;
}